import Link from 'next/link';

import { ChangeEvent } from 'react';

import { Drawer } from 'antd';

import { css } from '@emotion/react';
import { SearchType } from '@type/web/fraud';

import useResponsive from '@hook/useResponsive';

import Button from '@components/common/Button/Button';

import { FIELD_TYPE } from '../constant';

const placeHolderText = {
  PHONE_NUMBER: '하이픈(-)없이 숫자만 입력',
  ACCOUNT_NUMBER: '하이픈(-)없이 숫자만 입력',
  KAKAO_ID: '영문, 숫자, 빼기, 밑줄, 마침표만 입력',
  EMAIL: '영문, 숫자, 특수문자만 입력',
};

interface FraudSearchInputProps {
  fraudSearchForm: {
    type: SearchType;
    isValid: boolean;
    inputValue: string;
    visible: boolean;
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  };
  onToggle: () => void;
  handleOnKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleSelect: (type: SearchType) => void;
}

export default function FraudSearchInput({
  fraudSearchForm,
  onToggle,
  handleOnKeyPress,
  handleSelect,
}: FraudSearchInputProps) {
  const { isValid, inputValue, visible, handleChange, type } = fraudSearchForm;
  const { isPC } = useResponsive();

  return (
    <div css={wrap}>
      <div css={inputLayout}>
        <input
          css={inputStyle(isValid, inputValue.length)}
          type="text"
          placeholder={placeHolderText[type]}
          value={inputValue}
          onChange={handleChange}
          onKeyPress={handleOnKeyPress}
        />
        <Link href={{ pathname: '/fraud/result', query: { inputValue, type } }}>
          <a>
            <Button
              className="fraud-search-btn"
              css={searchButton}
              size="large"
              disabled={!isValid}
            >
              조회
            </Button>
          </a>
        </Link>
      </div>
      {isPC || (
        <Drawer
          css={drawerStyle}
          placement="bottom"
          title="조회선택"
          visible={visible}
          height={275}
          onClose={onToggle}
        >
          {Object.entries(FIELD_TYPE).map(([key, value]) => (
            <Button key={key} onClick={() => handleSelect(key as SearchType)}>
              {value}
            </Button>
          ))}
        </Drawer>
      )}
    </div>
  );
}

const wrap = css`
  width: 100%;
  display: flex;
`;

const drawerStyle = css`
  .ant-drawer-content {
    background-color: white;
    border-radius: 20px 20px 0 0;
    text-align: center;
    max-width: 1023px;
    margin: 0 auto;
  }
  .ant-drawer-body {
    padding: 15px;
    button {
      background-color: white;
      color: black;
      border-style: none;
    }
  }
  .ant-drawer-content-wrapper {
    box-shadow: none !important;
  }
  button {
    width: 100%;
    height: 48px;
    padding: 12px 24px;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    border: none;
  }
`;

const inputStyle = (isValid: boolean, inputLength: number) => css`
  outline: none;
  width: 100%;
  height: 44px;
  padding: 0 16px;
  color: #333;
  font-size: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  border-color: ${inputLength > 0 && !isValid && '#da1e28'};
  &::placeholder {
    color: #ccc;
  }
`;

const inputLayout = css`
  display: flex;
  margin-top: 8px;
  width: 100%;
`;

const searchButton = css`
  padding: 0px;
  min-width: 85px;
  height: 44px;
  margin-left: 8px;
  font-size: 16px;
  color: #fff;
  background: #ff6c2d;
  outline: none;
  border: none;
  border-radius: 5px;
  &:disabled {
    color: #fff;
    background: #ccc;
    &:hover {
      color: #fff;
      background: #ccc;
    }
  }
  &:hover {
    background: #ff6c2d;
    color: #fff;
  }
`;
